import { ReactComponent as FSM } from "assets/icons/fsm/default.svg"
import OutletRedirectChild from "components/Molecules/OutletRedirectChild"
import ImporterPage from "components/Templates/importer/ImporterPage"
import DemandForm from "pages/demand-placing/DemandForm"
import Demands from "pages/demand-placing/Demands"
import FieldStaffMangementPage from "pages/fsm"
import { QCBatchUploader } from "pages/qc-batch-uploader"
import PackagingMaterialDetail from "pages/scheduling-new/actions/PackagingMaterialDetail"
import TestPage from "pages/test"
import React, { lazy } from "react"
import { Outlet } from "react-router-dom"
import { VesaRouteType } from "routes"
import analyticsRoutes from "./analytics.routes"
import dataRoutes from "./data.routes"
import ecommerceRoutes from "./ecommerce.routes"
import { fsmRoutes } from "./fsm.routes"
import REGISTERATION_ROUTES from "./registration.routes"
import { vehicleRoutes } from "./vehicle.routes"
import PRODUCTION_ROUTES from "./production.routes"
const LazySchedulingNew = lazy(
  () => import("pages/scheduling-new/SchedulingPage")
)
const LazySupplierNew = lazy(
  () => import("pages/supplier/SupplierManagementPage")
)
const LazyWeighing = lazy(() => import("views/weighing.view"))
const LazyVehiclePage = lazy(() => import("pages/vehicle/VehiclePage"))
const LazyRegistration = lazy(() => import("../views/registration.view"))
const LazyReports = lazy(() => import("../pages/reports.page"))

// svg element
const mainRoutes: VesaRouteType[] = [
  {
    path: "test",
    icon: "lab-test",
    title: "Test",
    production: false,
    element: <TestPage />,
  },
  {
    icon: "dashboard",
    title: "Analytics",
    path: "analytics",
    permission: [
      "ds_view_dms_analytics",
      "ds_view_alternate_sales_analytics",
      "ds_view_stock_take_analytics",
    ],
    element: (
      <OutletRedirectChild basePath="/d/analytics" children={analyticsRoutes} />
    ),
    children: analyticsRoutes,
  },

  {
    icon: "feed",
    title: "Demand Broadcasting",
    path: "demands",
    permission: ["ds_view_demand"],
    element: <Outlet />,
    children: [
      {
        index: true,
        title: "All Demands",
        permission: ["ds_view_demand"],
        element: <Demands />,
      },
      {
        path: "new",
        title: "Create Demands",
        permission: ["ds_add_demand", "ds_edit_demand"],
        element: <DemandForm />,
        hide: true,
      },
    ],
  },
  {
    icon: "shopping-cart",
    path: "ecom",
    title: "Ecommerce",
    permission: ["ds_view_stock", "ds_view_order", "ds_view_dispatch"],
    element: (
      <OutletRedirectChild basePath="/d/ecom" children={ecommerceRoutes} />
    ),
    children: ecommerceRoutes,
  },
  {
    icon: "shop",
    title: "Supplier Management",
    path: "supplier",
    permission: ["vt_view_supplier_management"],
    element: <LazySupplierNew />,
  },
  {
    icon: "timeline-events",
    title: "Scheduling",
    permission: ["ds_view_schedule"],
    path: "scheduling",
    element: <LazySchedulingNew />,
  },
  {
    icon: "compressed",
    title: "Weighing",
    path: "weighing",
    permission: ["ds_view_inward"],
    element: <LazyWeighing />,
  },
  {
    path: "vehicle",
    permission: ["ds_view_vehicle_management"],
    icon: "drive-time",
    title: "Vehicle Management",
    element: <LazyVehiclePage />,
    children: vehicleRoutes,
  },
  {
    icon: "form",
    path: "registration",
    title: "Registration",
    element: <LazyRegistration />,
    children: REGISTERATION_ROUTES,
  },
  {
    icon: "cube",
    path: "allocation",
    title: "Production",
    children: PRODUCTION_ROUTES,
    permission: ["ds_view_production"]
  },


  {
    path: "fsm",
    icon: FSM,
    title: "Field Staff Management",
    element: <FieldStaffMangementPage />,
    children: fsmRoutes,
    permission: ["ds_view_fsm"],
  },
  {
    icon: "database",
    title: "Data View",
    path: "data",
    element: <OutletRedirectChild basePath="/d/data" children={dataRoutes} />,
    permission: ["ds_view_data"],
    children: dataRoutes,
  },
  {
    icon: "heat-grid",
    title: "Reports",
    path: "reports",
    element: <LazyReports />,
    permission: ["ds_view_report"],
  },
  {
    icon: "add-to-artifact",
    title: "Batch QC Uploader",
    path: "uploader",
    element: <QCBatchUploader />,
    permission: ["ds_view_batch_qc_uploader"],
  },
  {
    path: "import/:type",
    icon: "import",
    title: "Import",
    permission: ["ds_add_demand", "ds_add_order"],
    element: <ImporterPage />,
    hide: true,
  },
  {
    path: "packaging-material/:id",
    icon: "cube",
    title: "Packaging Material",
    element: <PackagingMaterialDetail />,
    hide: true,
  },
]

export default mainRoutes
